import SourceCenter from "./SourceCenter";

export default SourceCenter;
